import request from '@/utils/request'
import { uuid } from 'vue-uuid';
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function getMonthlyfeeGroup(){
  return request({
    url: `/api/monthlyfee/linkgroup`,
    method: "get"
  });
}

export function getMonthlyfeeGroupBy(name){
  return request({
    url: `/api/monthlyfee/linkgroup/group/${name}`,
    method: "get",
  });
}

export function searchMonthlyfeeGroupByMemberCode(membercode){
  return request({
    url: `/api/monthlyfee/linkgroup/search?membercode=${membercode}`,
    method: "get"
  });
}

export function createMonthlyfeeGroup(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/monthlyfee/linkgroup`,
    method: "post",
    data: data
  });
}

export function deleteMemberMonthlyfeeGroup(uid){
  return request({
    url: `/api/monthlyfee/linkgroup/${uid}`,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}

export function getMonthlyfeeGroupReport(data){
  return request({
    url: `/api/reports/fund-link-project${obj2query(data)}`,
    method: "get"
  });
}

export function getMonthlyfeeGroupReportExport(data, filename){

  const baseURL = process.env.VUE_APP_SERVER_BASE_API
    const link = document.createElement('a')
    data.access_token = getToken()
    link.href = `${baseURL}/api/reports/fund-link-project/excel${obj2query(data)}`
    if (filename) {
      link.download = filename
    }
    link.click()
}
